/* gloabl Keycloak */
let Vue;

class KeycloakPlugin extends Keycloak {

  async getValidToken() {
    try {
      await this.updateToken(30);
      return this.token;
    } catch (err) {
      return this.login();
    }
  }

  // Fix for bug in keycloak while using native promises
  login(){
    const loginPromise = super.login();
    loginPromise.success = loginPromise.then;
    loginPromise.error = loginPromise.catch;
    return loginPromise;
  }

  // Vue specific code required to hide away 'installing' the broker functionality on the Vue prototype
  install(_Vue) {
    if (Vue && _Vue === Vue) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(
          '[broker] already installed. Vue.use(MessageBroker) should be called only once.'
        );
      }
      return;
    }
    Vue = _Vue;
    Vue.prototype.$kauth = this;
  }

}

export default KeycloakPlugin;
